import { createTheme } from '@mui/material';

let theme = createTheme({
	components: {
		MuiSnackbar: {
			styleOverrides: {
				root: {
					width: '1200px',
				},
			},
		},
		MuiButton: {
			variants: [
				{
					props: { variant: 'contrast' },
					style: {
						color: '#000',
						borderColor: '#000',
						':hover': {
							backgroundColor: '#47505A',
						},
					},
				},
			],
		},
	},
	typography: {
		fontFamily: ['Lato', 'Lucida Grande', 'Tahoma', 'Sans-Serif'].join(','),
		button: {
			fontWeight: 700,
		},
		body1: {
			fontWeight: 500,
		},
		body2: {
			fontWeight: 400,
		},
		// Non standard headings - to be brought in line for the design system
		'dashboard-card-heading': {
			fontSize: 24,
			fontWeight: 400,
			lineHeight: '32px',
			color: '#6D787F',
		},
	},
	palette: {
		primary: {
			light: '#adc128',
			main: '#91A918',
			dark: '#5d6d0f',
		},
		secondary: {
			light: '#8f8f8f',
			main: '#6D787F',
			dark: '#47505A',
		},
		annualMileageFont: {
			light: '#1F2241',
			main: '#1F2241',
			dark: '#1F2241',
		},
		contrastThreshold: 3,
		tonalOffset: 0.2,
		background: {
			default: '#E2E4E6',
		},
		navigationButtonColor: {
			light: '#adc128',
			main: '#91A918',
			dark: '#5d6d0f',
		},
		regNumberColor: {
			main: '#91A918',
		},
		footer: {
			light: '#8f8f8f',
			main: '#494F5C',
			dark: '#3B424C',
		},
		icon: {
			main: '#91A918',
		},
	},
});

theme = createTheme(theme, {
	components: {
		MuiTypography: {
			defaultProps: {
				variantMapping: {
					'dashboard-card-heading': 'h2',
				},
			},
		},
		MuiPaper: {
			styleOverrides: {
				root: {
					borderRadius: 0,
				},
			},
		},
		MuiAppBar: {
			styleOverrides: {
				root: {
					background: theme.palette.common.white,
				},
			},
		},
		MuiFormLabel: {
			styleOverrides: {
				root: {
					color: theme.palette.common.black,
				},
			},
		},
		MuiOutlinedInput: {
			styleOverrides: {
				root: {
					borderColor: theme.palette.common.black,
				},
				notchedOutline: {
					borderColor: theme.palette.common.black,
				},
			},
		},
		MuiButton: {
			styleOverrides: {
				root: ({ ownerState }: { ownerState: { color: string; variant: string; id: string } }) => ({
					...(ownerState.variant !== 'text' &&
						ownerState.variant !== 'outlined' && {
							color: theme.palette.common.white,
						}),
					...(ownerState.variant !== 'text' &&
						ownerState.variant !== 'outlined' && {
							...(ownerState.color === 'secondary' && {
								borderColor: theme.palette.common.black,
								':hover': {
									backgroundColor: 'rgba(73, 79, 92,0.9)',
								},
							}),
							...(ownerState.color === 'primary' && {
								borderColor: theme.palette.common.black,
								':hover': {
									backgroundColor: 'rgba(173, 193, 40, 0.9)',
								},
							}),
						}),
				}),
			},
			variants: [
				{
					props: { variant: 'link' },
					style: {
						...theme.typography.body1,
						color: theme.palette.primary.main,
						textDecoration: 'underline',
						padding: 0,
						background: 'transparent',
						'&:hover': {
							color: theme.palette.primary.light,
							background: 'transparent',
							textDecoration: 'underline',
						},
						'&:visited': {
							background: 'transparent',
							color: theme.palette.primary.main,
							'&:hover': {
								color: theme.palette.primary.light,
							},
						},
					},
				},
			],
		},
		MuiToggleButton: {
			styleOverrides: {
				root: {
					color: theme.palette.common.black,
					borderColor: theme.palette.common.black,
					'&.Mui-selected': {
						backgroundColor: theme.palette.primary.main,
						color: theme.palette.common.white,
						'&:hover': {
							backgroundColor: theme.palette.primary.main,
						},
					},
				},
			},
		},
		MuiCssBaseline: {
			styleOverrides: `
        body, html, #root {
          height: 100%;
        }
        html {
          overflow-y: scroll;
        }
        /* ===== Scrollbar CSS ===== */
        /* Firefox */
        * {
          scrollbar-width: thin;
          scrollbar-color: ${theme.palette.grey[500]} ${theme.palette.background.default};
        }

        /* Chrome, Edge, and Safari */
        *::-webkit-scrollbar {
          width: 12px;
        }

        *::-webkit-scrollbar-track {
          background: ${theme.palette.background.default};
        }

        *::-webkit-scrollbar-thumb {
          background-color: ${theme.palette.grey[500]};
          border-radius: 10px;
          border: 3px solid ${theme.palette.background.default};
        }`,
		},
	},
});

const themeExport = theme;
export default themeExport;
